var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"label":"version","filled":"","value":_vm.version,"items":_vm.versions,"return-object":"","item-value":"value","item-text":"text"},on:{"input":_setup.handleInput},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('div',[_vm._v(" "+_vm._s(data.item.text)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }